import { DatePicker } from "antd";
import Colors from "assets/Colors";
import es from "antd/es/date-picker/locale/es_ES";

const dateFormat = "YYYY/MM/DD";

function DatePickerSelect(props) {
  return (
    <DatePicker
      {...props}
      style={{
        height: "40px",
        width: "100%",
        borderColor: props.valid
          ? Colors.notification_failed
          : Colors.background_dividers,
        borderRadius: "2px",
        borderStyle: "solid",
        ...props.style,
      }}
      format={dateFormat}
      locale={es}
    />
  );
}

export default DatePickerSelect;
